import { Button, type ButtonProps } from '@florencelabs/button';
import clsx from 'clsx';
import React, { FC } from 'react';

export interface ActionData {
  text: string;
  onClick: () => void;
  icon?: ButtonProps['icon'];
  isHiddenOnMobile?: boolean;
  isLoading?: boolean;
  className?: string;
}

interface AppointmentSummaryActionsProps {
  action1: ActionData;
  action2: ActionData;
}

export const AppointmentSummaryActions: FC<AppointmentSummaryActionsProps> = ({
  action1,
  action2,
}) => {
  return (
    <div
      className={
        'flex flex-col items-stretch gap-3 pt-4 min-[640px]:flex-row print:hidden'
      }
    >
      <Button
        testId={'scheduling-action1-btn'}
        variant={'systemOutline'}
        onPress={action1.onClick}
        iconPosition={'left'}
        icon={action1.icon}
        className={clsx(
          'min-w-fit flex-1 !py-[10px] px-6',
          action1.isHiddenOnMobile && 'hidden desktop:block',
          action1.className,
        )}
        isLoading={action1.isLoading}
      >
        {action1.text}
      </Button>
      <Button
        testId={'scheduling-action2-btn'}
        variant={'clientMain'}
        className={clsx(
          'min-w-fit flex-1 !py-[10px] px-6',
          action2.isHiddenOnMobile && 'hidden desktop:block',
          action2.className,
        )}
        onPress={action2.onClick}
        iconPosition={'left'}
        icon={action2.icon}
        isLoading={action2.isLoading}
      >
        {action2.text}
      </Button>
    </div>
  );
};
